'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
exports.default = eauors;
var _constants = require('../utils/constants');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function wrapperUpdate(selection, options) {
  selection.style({
    position: 'relative',
    // the width should not be a constraint at this level
    // width: options.width+'px',
    height: options.outerHeight + 'px'
  });
}
function chartUpdate(selection, options) {
  selection.attr({
    width: '100%',
    height: '100%'
  });
}
function containerUpdate(selection, options) {
  selection.attr({
    width: options.width,
    height: options.height,
    transform: 'translate(' + options.margin + ', ' + options.margin + ')'
  });
}
function tooltipUpdate(selection, options) {
  selection.style({
    visibility: _constants.HIDDEN
  });
}
function eauors(target) {
  target.eauors = (0, _extends3.default)({}, target.eauors, {
    wrapperUpdate: wrapperUpdate,
    chartUpdate: chartUpdate,
    containerUpdate: containerUpdate,
    tooltipUpdate: tooltipUpdate
  });
}